import { render, staticRenderFns } from "./EditCertificate.vue?vue&type=template&id=21ebd1e2&scoped=true&"
import script from "./EditCertificate.vue?vue&type=script&lang=js&"
export * from "./EditCertificate.vue?vue&type=script&lang=js&"
import style0 from "./EditCertificate.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./EditCertificate.vue?vue&type=style&index=1&id=21ebd1e2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ebd1e2",
  null
  
)

export default component.exports